// import {Dropdown} from "./Dropdown"
import {TeamDisplay} from "./TeamDisplay"
import {SearchBar} from "./SearchBar"

export const TeamCard = ({teamName, setTeam, team}) => {

    return (
        <div style={{width: "40%", border: "1px solid black"}}>
            <div style={{padding: "1rem", backgroundColor: "#22356E", fontWeight: 'bold', color: "white"}}>
                {teamName} receives:
            </div>

            <SearchBar team={team} setTeam={setTeam} />
            <TeamDisplay team={team} setTeam={setTeam} />
        </div>
    )
}